import InvoiceIconDuotone from '@/components/icons/InvoiceIconDuotone';
import { useTranslation } from 'react-i18next';

const SettlementsDetailsEmpty = () => {
    const { t } = useTranslation();

    return (
        <div className="h-full flex-1 flex flex-col items-center justify-center gap-2">
            <InvoiceIconDuotone className="size-8" />
            <div className="w-80 flex flex-col gap-1 text-center">
                <h3 className="text-lg font-medium">
                    {t('main.finances.components.settlements.components.pageEmpty.title')}
                </h3>
                <p className="text-sm text-popover-600">
                    {t('main.finances.components.settlements.components.pageEmpty.description')}
                </p>
            </div>
        </div>
    );
};

export default SettlementsDetailsEmpty;
